import { types } from 'mobx-state-tree';
import Role from './Role';

const Account = types
  .model('Account', {
    id: types.identifierNumber,
    email: types.string,
    firstName: types.string,
    lastName: types.string,
    roles: types.array(Role)
  })
  .views(self => {
    return {
      hasRole(roleName : string) : boolean {
        return self.roles.findIndex(role => role.name === roleName) !== -1;
      }
    }
  });

export default Account;
export type IAccount = typeof Account.Type;